import { Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { MapColoringScore } from "./MapColoringScore";
import { MapColoringTreatment } from "./MapColoringTreatment";
import { useMemo } from "react";
import { CraAttributes } from "@keita/lanepatrol-sdk";
import {
  MapColoring,
  MapColoringType,
} from "../../../../map/models/MapColoring";
import { tScoreType } from "../../../../coding/utils/score-utils";
import { CraAttributeUtils } from "../../../../coding/utils/attribute-utils";
import { CraColoringAttribute } from "./CraColoringAttribute";
import { HlaColoringAttribute } from "../HlaColoringLegend/HlaColoringAttribute";

const MapColoringLegendBase = ({
  coloring,
  speedUnit,
}: {
  coloring: MapColoring;
  speedUnit: string;
}) => {
  const [text, content] = useMemo(() => {
    switch (coloring.type) {
      case MapColoringType.Score:
        return [
          coloring.scoreKey === "global"
            ? "Global score"
            : tScoreType(coloring.scoreKey),
          <MapColoringScore />,
        ];
      case MapColoringType.Treatment:
        return [
          t(`sdk:treatments.${coloring.treatmentType}`),
          <MapColoringTreatment />,
        ];
      case MapColoringType.CraAttribute:
        const attribute = CraAttributes.getByName(coloring.attributeName)!;
        return [
          CraAttributeUtils.getLabel(coloring.attributeName),
          <CraColoringAttribute attribute={attribute} />,
        ];
      case MapColoringType.HlaAttribute:
        return [
          t(`shared:hlaAttribute.${coloring.attributeName}`, {
            speedUnit,
          }),
          <HlaColoringAttribute attributeName={coloring.attributeName} />,
        ];
    }
  }, [coloring, speedUnit]);

  return (
    <>
      <Text fontSize="sm" fontWeight="semibold">
        {text}
      </Text>
      {content}
    </>
  );
};

export const MapColoringLegend = observer(MapColoringLegendBase);
